<p-drawer
  #drawer
  [visible]="this.visible()"
  appendTo="body"
  (onHide)="this.visibleChange.emit(false)"
  [closeOnEscape]="true"
  [position]="'right'"
  [closable]="false"
  [modal]="true"
  styleClass="w-100 w-md-75"
>
  <ng-template #header>
    <h3 i18n="@@add-mcp-server-external">MCP-Server hinzufügen (Extern)</h3>
  </ng-template>
  <ng-template #content>
    <form
      id="myForm"
      [formGroup]="form"
      class="d-flex flex-column"
    >
      <div class="d-flex flex-column gap-3 form-content">
        <div class="d-flex flex-row gap-2">
          <label
            for="managedEnabled"
            i18n="@@enabled"
          >Standardmäßig aktiv</label>
          <p-toggleswitch
            id="managedEnabled"
            formControlName="enabled"
          />
        </div>

        <div
          formGroupName="tool"
          class="d-flex flex-column gap-3 "
        >
          <p-floatlabel variant="on">
            <input
              pInputText
              fluid
              id="server_label"
              type="text"
              formControlName="server_label"
              [pKeyFilter]="server_label_regex"
            >
            <label
              for="server_label"
              i18n="@@mcp-server-label"
            >Server Label</label>
          </p-floatlabel>
          <p-floatlabel variant="on">
            <input
              fluid
              id="server_url"
              #server_url
              type="url"
              pInputText
              formControlName="server_url"
              (blur)="this.loadSelectedServerTools(server_url.value)"
            >
            <label
              for="server_url"
              i18n="@@mcp-server-url"
            >URL</label>
          </p-floatlabel>
          <p-floatlabel variant="on">
            <input
              fluid
              id="server_description"
              type="text"
              formControlName="server_description"
              pInputText
            >
            <label
              for="server_description"
              i18n="@@mcp-server-description"
            >Bescheibung</label>
          </p-floatlabel>


          <p-floatlabel variant="on">
            <p-select
              fluid
              id="authmethod"
              [(ngModel)]="this.selectedAuthMethod"
              [ngModelOptions]="{ standalone: true }"
              [options]="this.authMethods"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
            />
            <label
              for="authmethod"
              i18n="@@mcp-server-authmethod"
            >Authentication</label>
          </p-floatlabel>
          @switch (selectedAuthMethod()) {
          @case ("token") {
          <p-floatlabel variant="on">
            <p-select
              fluid
              id="secret"
              [options]="this.secretService.projectSecrets"
              formControlName="authorization"
              optionLabel="name"
              optionValue="name"
              emptyMessage="Es wurden keine auswählbaren Projekt-Secrets gefunden."
              i18n-emptyMessage="@@no-project-secrets-found"
              (onChange)="this.onAuthSecretChanged()"
            />
            <label
              for="secret"
              i18n="@@mcp-server-authorization-secret"
            >API-Token / Authorization</label>
          </p-floatlabel>
          <small
            class="text-muted"
            i18n="@@mcp-server-secret-reload-hint"
          >Nach Auswahl des Secrets werden die verfügbaren Tools automatisch neu geladen, damit auch nicht öffentliche
            Tools erkannt werden.</small>
          }
          @case ("header") {
          <ng-container formArrayName="headers">
            @for (row of headerRows.controls; track row) {
            <div
              class="position-relative"
              [formGroupName]="$index"
            >
              <div class="row align-items-center">
                <div class="col">
                  <p-floatlabel
                    variant="on"
                    class="header-key-floatlabel"
                  >
                    <input
                      pInputText
                      fluid
                      [id]="'header_name_' + $index"
                      type="text"
                      formControlName="key"
                      [class.header-key-input--duplicate]="isDuplicateHeader($index)"
                    >
                    @if (isDuplicateHeader($index)) {
                    <span
                      class="header-duplicate-indicator"
                      i18n-pTooltip="@@duplicate-header"
                      pTooltip="Der Name ist bereits vergeben"
                      tooltipPosition="left"
                    >!</span>
                    }
                    <label
                      [for]="'header_name_' + $index"
                      i18n="@@mcp-server-header-name"
                    >Header</label>
                  </p-floatlabel>
                </div>
                <div class="col-auto px-0">
                  <span>:</span>
                </div>
                <div class="col">
                  <p-floatlabel variant="on">
                    <p-select
                      fluid
                      [id]="'secret_' + $index"
                      [options]="this.secretService.projectSecrets"
                      formControlName="value"
                      optionLabel="name"
                      optionValue="name"
                      (onChange)="this.onAuthSecretChanged()"
                    />
                    <label
                      [for]="'secret_' + $index"
                      i18n="@@mcp-server-secret"
                    >Secret</label>
                  </p-floatlabel>
                </div>
              </div>
              <button
                type="button"
                class="remove-row-btn remove-row-btn--floating"
                (click)="this.removeHeaderRow($index)"
                title="Entfernen"
              >
                <i class="ri-close-line"></i>
              </button>
            </div>
            }
          </ng-container>
          <p-button
            type="button"
            [outlined]="true"
            severity="secondary"
            fluid
            label="Header hinzufügen"
            i18n-label="@@add-header-row"
            icon="ri-add-line"
            (click)="this.addHeaderRow()"
          />
          <small
            class="text-muted"
            i18n="@@mcp-server-secret-reload-hint"
          >Nach Auswahl des Secrets werden die verfügbaren Tools automatisch neu geladen, damit auch nicht öffentliche
            Tools erkannt werden.</small>
          }
          }
        </div>
        @if(this.serverTools().length > 0) {
        <p-table
          [value]="this.serverTools()"
          [(selection)]="this.selectedServerTools"
          dataKey="name"
          styleClass="mcp-tools-table"
        >
          <ng-template #header>
            <tr>
              <th style="padding-left: unset">Tool</th>
              <th class="approval-column">
                <p-floatlabel variant="on">
                  <p-select
                    styleClass="approval-select"
                    id="globalApproval"
                    [options]="globalToolApprovalOptions"
                    optionLabel="label"
                    optionValue="value"
                    optionDisabled="disabled"
                    appendTo="body"
                    [ngModel]="globalToolApproval()"
                    (ngModelChange)="setGlobalToolApproval($event)"
                    [ngModelOptions]="{ standalone: true }"
                  />
                  <label
                    for="globalApproval"
                    i18n="@@mcp-user-approval-all"
                  >User approval (alle Tools)</label>
                </p-floatlabel>
              </th>
              <th class="checkbox-column">
                <div class="d-flex justify-content-end">
                  <p-tableHeaderCheckbox />
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template
            #body
            let-tool
          >
            <tr>
              <td style="padding-left: unset">
                <div class="d-flex flex-column">
                  <span>{{ tool.title }} ({{ tool.name }})</span>
                  <small>{{ tool.description }}</small>
                </div>
              </td>
              <td class="approval-column">
                <p-select
                  styleClass="approval-select"
                  [options]="toolApprovalOptions"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  [ngModel]="getToolApproval(tool.name)"
                  (ngModelChange)="setToolApproval(tool.name, $event)"
                  [ngModelOptions]="{ standalone: true }"
                />
              </td>
              <td class="checkbox-column">
                <div class="d-flex justify-content-end">
                  <p-tableCheckbox [value]="tool" />
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
        }
        @if(this.toolsLoadState() === 'loading') {
        <p class="text-muted">
          <i class="ri-loader-2-line"></i>
          <span i18n="@@mcp-tools-loading">Tools werden geladen…</span>
        </p>
        }
        @if(this.toolsLoadState() === 'empty') {
        <p class="text-warning">
          <i class="ri-alert-line"></i>
          <span i18n="@@mcp-tools-empty">Dieser Server hat keine Tools zurückgegeben. Prüfe, ob die URL ein gültiger
            MCP-Server ist.</span>
        </p>
        }
        @if(this.toolsLoadState() === 'error') {
        <p class="text-danger">
          <i class="ri-error-warning-line"></i>
          <span i18n="@@mcp-tools-error">Die Tools konnten nicht geladen werden. Prüfe, ob die URL erreichbar und ein
            gültiger MCP-Server ist.</span>
        </p>
        }
        <p-button
          label="Speichern"
          severity="primary"
          styleClass="align-self-start"
          (click)="this.submit()"
          type="submit"
        />
      </div>
    </form>
  </ng-template>
</p-drawer>